export { es } from '@payloadcms/translations/languages/es'
